<template>
    <div class="page404">
        <p class="page404__name" v-html="title"></p>
        <p class="page404__text" v-html="text"></p>
        <div class="page404__link_container">
            <router-link class="arrow" v-for="(value, index) in burger_name" :key="value.id" 
                :to="{name: `${langUrl === 'ru' ? burger_url[index] + 'Ru' : burger_url[index] + 'En'}`}">
                <button @click="show = false" class="header__btn__nav">{{value}}</button>
            </router-link>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import VueAxios from 'vue-axios'
import { HTTP, Routes } from '../API';


export default {
    data: () => ({
        menu_name: null,
        menu_url: null,
        burger_name: null,
        burger_url: null,
        title: '404',
        text: 'Похоже, запрашиваемая вами страница не найдена'
        // lang: null
    }),
    props: {
        lang: {type: String},
        langUrl: {type: String}
    },
    watch: {
        lang: function(newValue, oldValue){
            this.getContent();
        }
    },
    mounted: function () {
        this.getContent();
        
        // axios
        // .get('https://macchocolate.ru/api/api_burger_menu/')
        // .then(response => {
        //     this.burger_name = response.data.burger_name
        //     this.burger_url = response.data.burger_url
        // })
    },
    methods: {   
        getContent(){
            if (this.lang !== undefined && this.lang !== null) {
                HTTP.get(Routes.burger_menu)
                    .then(response => {
                        // let respons = response.data.UserLng
                        // console.log('response.data: ', response.data);
                        // console.log('response.data[this.lang]: ', response.data[this.lang]);
                        // this.lang = respons
                        this.burger_name = response.data[this.lang].burger_name
                        
                        this.burger_url = response.data[this.lang].burger_url
                        
                })        
                HTTP.get(Routes.error)
                    .then(response => {
                        this.title = response.data[this.lang].title
                        this.text = response.data[this.lang].post
                    })
            }
        }
    }
    
}
</script>